export class LocalStorage {
    _sessionInfo: any = {};

    setItemToStorage(key: string, value: any) {
        if (value) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    getItemFromStorage(key: string) {
        let item = localStorage.getItem(key);

        if (item !== null && typeof item === 'string') {
            let itemValue = null;
            try {
                itemValue = JSON.parse(item);
            } catch (err) {}
            return itemValue;
        } else {
            return item;
        }
    }

    removeItemFromStorage(key: string) {
    localStorage.removeItem(key);
    }

    clean() {
        this._sessionInfo = {};
        if (Storage !== undefined) {
            Object.keys(localStorage).forEach((key: any) => {
                if (key.startsWith('tmsClient-')) {
                    localStorage.removeItem(key);
                }
            });
        }
    }

    private getFromSessionOrStorage(key: string, isObject: boolean) {
        key = this.addPrefix(key);
        return (
            this.getSessionData(key) || this.getFromStorageAndSetToSessionDataIfExist(key, isObject)
        );
    }

    private setToSessionAndLocalStorage(key: string, value: any, isObject: boolean) {
        key = this.addPrefix(key);
        this.setSessionData(key, value);
        if (Storage !== undefined) {
            this.setToStorage(key, value, isObject);
        }
    }

    private getFromStorageAndSetToSessionDataIfExist(key: string, storedAsObject: boolean) {
        if (storedAsObject) {
            if (localStorage.getItem(key) !== null) {
                this.setSessionData(key, this.getItemFromStorage(key));
                return this.getSessionData(key);
            }
        } else {
            if (localStorage[key]) {
                this.setSessionData(key, localStorage[key]);
                return this.getSessionData(key);
            }
        }
        return null;
    }

    private setToStorage(key: string, value: any, storedAsObject: boolean) {
        if (storedAsObject) this.setItemToStorage(key, value);
        else localStorage[key] = value;
    }

    private setSessionData(key: string, value: any) {
        key = this.addPrefix(key);
        this._sessionInfo[key] = value;
    }

    private getSessionData(key: string): any {
        key = this.addPrefix(key);
        return (<any>this._sessionInfo)[key];
    }

    private removeSessionData(key: string) {
        delete this._sessionInfo[key];
    }

    private addPrefix(key: string) {
        if (!key.startsWith('tmsClient-')) {
            key = 'tmsClient-' + key;
        }
        return key;
    }
}

export default new LocalStorage();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/localStorageUtil/localStorageUtil.ts